import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import GameFileWorks from "./components/EventNewYearAndChristmas_2024/NewYear";
import ModalLogin from "../component/ModalLogin";
import { useParams } from "react-router";
import {
  ID_TAB_EVENT_NEW_YEAR,
  PYPE_ACTIVE_EVENT_NEW_YEAR_2024,
  STATUS_ACTIVE_EVENT_NEW_YEAR_2024,
  ID_TAB_END_EVENT_NEW_YEAR,
} from "../helper/const";
import ChristmasTree from "./components/EventNewYearAndChristmas_2024/ChristmasTree";
import Instruction from "./components/EventNewYearAndChristmas_2024/Instruction";
import Congratulation from "./components/EventNewYearAndChristmas_2024/Congratulation";
import RankTable from "./components/EventNewYearAndChristmas_2024/RankTable";
import SpecialCode from "./components/EventNewYearAndChristmas_2024/SpecialCode";
import styled from "styled-components";
import iconMenu from "../assets/images/Event-2024/image 37 (1).png";
import Menu from "./components/EventNewYearAndChristmas_2024/components/Menu";
import Snow from "./components/EventNewYearAndChristmas_2024/components/Snow";
import { curStateAccount, curStateEventNewYear2024 } from "../Redux/selector";
import { getConfigEventNewYear2024 } from "../Redux/futures/event-new-year-noel/actions";

export default function EventNewYearAndChristmas_2024() {
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();
  const selectorAccount = useSelector(curStateAccount);
  const { statusEvent } = useSelector(curStateEventNewYear2024) || {};

  useEffect(() => {
    if(selectorAccount.userInfo) {
      dispatch(getConfigEventNewYear2024());
    }
  }, [selectorAccount.userInfo]);

  const handleGetTab = () => {
    if (!statusEvent?.is_finished) {
      switch (id) {
        case ID_TAB_EVENT_NEW_YEAR.gameFireworks:
          return <GameFileWorks setOpenModalLogin={setOpenModalLogin} />;
        case ID_TAB_EVENT_NEW_YEAR.christmasTree:
          return <ChristmasTree setOpenModalLogin={setOpenModalLogin}/>;
        case ID_TAB_EVENT_NEW_YEAR.instruction:
          return <Instruction />;
        case ID_TAB_EVENT_NEW_YEAR.rankTable:
          return <RankTable />;
        case ID_TAB_EVENT_NEW_YEAR.specialCode:
          return <SpecialCode setOpenModalLogin={setOpenModalLogin} />;
        default:
          return;
      }
    } else {
      switch (id) {
        case ID_TAB_EVENT_NEW_YEAR.rankTable:
          return <RankTable />;
        case ID_TAB_EVENT_NEW_YEAR.instruction:
          return <Instruction />;
        case ID_TAB_EVENT_NEW_YEAR.congratulation:
          return <Congratulation />;
        default:
          return;
      }
    }
  };

  if (+statusEvent?.is_show !== PYPE_ACTIVE_EVENT_NEW_YEAR_2024) {
    return;
  }
  return (
    <>
      <Div>
        <div className="icon-menu-head">
          <img src={iconMenu} alt="" />
        </div>
        <div className="container-detail-event">
          <Menu statusEvent={statusEvent}/>
          {handleGetTab()}
        </div>
        <Snow />
      </Div>
      <ModalLogin
        open={openModalLogin}
        setOpenModalLogin={setOpenModalLogin}
        isGetContainer={false}
      />
    </>
  );
}
const Div = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;

  .container-animation-snow {
    margin-top: 74px;
  }

  #id-now-container {
    width: 100%;
    height: calc(100% - 74px);
    margin-top: 74px;
    position: absolute;
    top: 0;
    pointer-events: none;
  }

  .position-relative {
    position: relative;
  }

  .container-main-event-2024 {
    width: 100%;
    height: calc(100% - 74px);
    position: relative;
  }

  .container-detail-event {
    position: relative;
    width: 100%;
    height: 100%;

    /* overflow-y: hidden; */
    /* overflow: hidden; */
    z-index: 1;
  }

  .icon-menu-head {
    position: absolute;
    pointer-events: none;
    top: 50px;
    z-index: 2;
    width: calc(100% + 80px);
    left: -45px;

    img {
      width: calc(100% + 90px);
    }
  }

  @media (max-width: 1400px) {
    .icon-menu-head {
      position: absolute;
      top: 40px;
      z-index: 2;
      width: calc(100% + 45px);
      left: -25px;

      img {
        height: 100px;
      }
    }
    .container-main-event-2024 {
      height: calc(100% - 60px);
    }
  }

  @media (max-width: 992px) {
    height: calc(100% + 120px);
    padding-bottom: 120px;
    margin-top: 20px;
  }

  @media (max-width: 576px) {
    margin-top: 10px;

    .icon-menu-head img {
      height: 60px;
    }

    .icon-menu-head{
      top: 45px;
    }

   .custom-next-event{
      right: 2px;
    }

    .custom-prev-event{
      left: 2px;
    }

    .btn-custom-event {
      padding: 0;
      span {
        width: 12px;
      }
    }
  }
`;
